import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/w3era/w3eraacademy_nextjsapp/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ApiProvider"] */ "/home/w3era/w3eraacademy_nextjsapp/src/helpers/apiContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardProvider"] */ "/home/w3era/w3eraacademy_nextjsapp/src/helpers/dashboardContext.tsx");
